import { Component, inject } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogModule,
	MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
	standalone: true,
	selector: 'lmc-dialog',
	templateUrl: 'lmc-dialog.component.html',
	imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class LmcDialogComponent {
	readonly dialogRef = inject(MatDialogRef<LmcDialogComponent>);
	readonly data = inject<LmcDialogData>(MAT_DIALOG_DATA);
}

export interface LmcDialogData {
	title: string;
	content: string;
	positiveButtonText?: string;
	negativeButtonText?: string;
}
